import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <Flex minH="100vh" align="center" justify="center" bg="bg.canvas" px={4}>
      <Box
        w="100%"
        maxW="420px"
        bg="bg.surface"
        borderWidth="1px"
        borderColor="border.subtle"
        borderRadius="md"
        p={8}
      >
        <Outlet />
      </Box>
    </Flex>
  );
}
